import React from 'react';
import { View as RNView, ViewProps } from 'react-native';
import Box from './Box';

// Simple View component that can be used as a drop-in replacement for native-base View
// It extends React Native's View with additional props for easier migration
interface ViewPropsExtended extends ViewProps {
  // Layout props
  flex?: number;
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  alignSelf?: 'auto' | 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';

  // Spacing props
  marginTop?: number | string;
  marginBottom?: number | string;
  marginLeft?: number | string;
  marginRight?: number | string;
  paddingTop?: number | string;
  paddingBottom?: number | string;
  paddingLeft?: number | string;
  paddingRight?: number | string;
  paddingX?: number | string; // paddingHorizontal
  paddingY?: number | string; // paddingVertical
  marginX?: number | string; // marginHorizontal
  marginY?: number | string; // marginVertical

  // Background
  bg?: string; // backgroundColor
  backgroundColor?: string;

  // Border
  rounded?: 'sm' | 'md' | 'lg' | 'xl' | 'full' | number;
  borderRadius?: number;
  borderWidth?: number | string;
  borderColor?: string;

  // Dimensions
  width?: number | string;
  height?: number | string;
  minWidth?: number | string;
  minHeight?: number | string;
  maxWidth?: number | string;
  maxHeight?: number | string;

  // NativeBase theme variants (we'll ignore these for now)
  _dark?: any;
  _light?: any;
  _hover?: any;
  _focus?: any;
  _pressed?: any;
  _disabled?: any;
}

const View: React.FC<ViewPropsExtended> = props => {
  // If any enhanced props are used, use Box component
  const hasEnhancedProps =
    props.flex !== undefined ||
    props.flexDirection !== undefined ||
    props.justifyContent !== undefined ||
    props.alignItems !== undefined ||
    props.alignSelf !== undefined ||
    props.marginTop !== undefined ||
    props.marginBottom !== undefined ||
    props.marginLeft !== undefined ||
    props.marginRight !== undefined ||
    props.paddingTop !== undefined ||
    props.paddingBottom !== undefined ||
    props.paddingLeft !== undefined ||
    props.paddingRight !== undefined ||
    props.paddingX !== undefined ||
    props.paddingY !== undefined ||
    props.marginX !== undefined ||
    props.marginY !== undefined ||
    props.bg !== undefined ||
    props.rounded !== undefined ||
    props.borderRadius !== undefined ||
    props.borderWidth !== undefined ||
    props.borderColor !== undefined ||
    props.width !== undefined ||
    props.height !== undefined ||
    props.minWidth !== undefined ||
    props.minHeight !== undefined ||
    props.maxWidth !== undefined ||
    props.maxHeight !== undefined ||
    props._dark !== undefined ||
    props._light !== undefined ||
    props._hover !== undefined ||
    props._focus !== undefined ||
    props._pressed !== undefined ||
    props._disabled !== undefined;

  if (hasEnhancedProps) {
    return <Box {...props} />;
  }

  // For simple cases, just use React Native's View
  return <RNView {...props} />;
};

export default View;
